@if (menuModel.selectedCategory() && anchorPanel) {
    <div class="menu-contents" woa-responsive
         [ngClass]="{
             'with-description-only': !showMainCategoryHeader() && menuModel.getMenuCategoryDescription(menuModel.selectedCategory()),
             'with-images': menuModel.showItemImages()()
         }"
         [woa-css-var]="{'--anchor-panel-height': anchorPanelHeight() + 'px'}">
        @if (!showMainCategoryHeader() && menuModel.getMenuCategoryDescription(menuModel.selectedCategory())) {
            <div class="menu-contents-description"
                 [innerHtml]="menuModel.getMenuCategoryDescription(menuModel.selectedCategory()) | html"></div>
        }
        @if (showMainCategory()) {
            <div class="menu-contents-category" #anchorTarget>
                @if (showMainCategoryHeader()) {
                    <div class="menu-contents-category-header" woa-activatable
                         (onActivate)="menuModel.selectAnchor(0, false, $event)">
                        @if (showMainCategoryImage()) {
                            <div class="menu-contents-category-header-image">
                                <img class="menu-contents-category-header-image-object" alt=""
                                     [woa-image-cache]="menuModel.getCategoryImage()(menuModel.selectedCategory())">
                            </div>
                        }
                        <div class="menu-contents-category-header-details">
                            <div class="menu-contents-category-header-details-name"
                                 [ngClass]="{
                                     'with-image': showMainCategoryImage()
                                 }">
                                {{ menuModel.getCategoryDisplayName()(menuModel.selectedCategory()) }}
                            </div>
                            @if (showClosePromoAction() && menuModel.selectedCategory() && !menuModel.selectedCategory()?.id) {
                                <woa-link class="menu-contents-category-header-details-action"
                                          [link]="'woa.button.common.close'"
                                          (onActivate)="menuModel.deactivatePromotedCategory()"></woa-link>
                            }
                        </div>
                        @if (menuModel.getMenuCategoryDescription(menuModel.selectedCategory())) {
                            <div class="menu-contents-category-header-description"
                                 [innerHtml]="menuModel.getMenuCategoryDescription(menuModel.selectedCategory()) | html"></div>
                        }
                    </div>
                }
                <div class="menu-contents-category-items" #items
                     [ngClass]="{
                         'tile': itemColumns(items) > 1 && menuModel.showItemImages()(),
                         'with-header': showMainCategoryHeader()
                     }"
                     [woa-css-var]="{'--item-columns': itemColumns(items)}">
                    @for (menuItem of menuModel.getCategoryItems()(menuModel.selectedCategory()); track menuItem; let i = $index) {
                        <woa-menu-item-panel class="menu-contents-category-items-item" id="item-{{i}}"
                                             [category]="menuModel.selectedCategory()" [menuItem]="menuItem"
                                             [tile]="itemColumns(items) > 1 && menuModel.showItemImages()()"></woa-menu-item-panel>
                    }
                </div>
            </div>
        }
        <!--suppress JSUnusedGlobalSymbols -->
        @for (subcategory of menuModel.selectedCategorySubcategories(); track subcategory; let i = $index) {
            <div class="menu-contents-category subcategory" id="subcategory-{{i}}" #anchorTarget>
                <div class="menu-contents-category-header" woa-activatable
                     (onActivate)="menuModel.selectAnchor(i + (menuModel.selectedCategoryHasMainCategoryItems() ? 1 : 0), false, $event)">
                    @if (menuModel.showSubcategoryImages() && menuModel.getCategoryImage()(subcategory)) {
                        <div class="menu-contents-category-header-image">
                            <img class="menu-contents-category-header-image-object" alt=""
                                 [woa-image-cache]="menuModel.getCategoryImage()(subcategory)">
                        </div>
                    }
                    <div class="menu-contents-category-header-details">
                        <div class="menu-contents-category-header-details-name"
                             [ngClass]="{'with-image': menuModel.showSubcategoryImages() && menuModel.getCategoryImage()(subcategory)}">
                            {{ menuModel.getCategoryDisplayName()(subcategory) }}
                        </div>
                    </div>
                    @if (menuModel.getMenuCategoryDescription(subcategory)) {
                        <div class="menu-contents-category-header-description"
                             [innerHtml]="menuModel.getMenuCategoryDescription(subcategory) | html"></div>
                    }
                </div>
                <div class="menu-contents-category-items with-header" #items
                     [ngClass]="{'tile': itemColumns(items) > 1 && menuModel.showItemImages()()}"
                     [woa-css-var]="{'--item-columns': itemColumns(items)}">
                    @for (menuItem of menuModel.getCategoryItems()(subcategory); track menuItem; let j = $index) {
                        <woa-menu-item-panel class="menu-contents-category-items-item" id="subcategory-item-{{i}}-{{j}}"
                                             [category]="subcategory" [menuItem]="menuItem"
                                             [tile]="itemColumns(items) > 1 && menuModel.showItemImages()()"
                                             [showDetails]="menuModel.selectedCategorySubcategories().length == 1 || anchorTargetHasBeenVisible()[i]"></woa-menu-item-panel>
                    }
                </div>
            </div>
        }
    </div>
}
@if (showBackButton()) {
    <div class="menu-nav">
        <div class="menu-nav-message">{{ 'woa.message.item-selection.back-query' | translate }}</div>
        <woa-button class="menu-nav-action" [label]="'woa.button.item-selection.back'"
                    [prominence]="ButtonProminence.LOW"
                    (onActivate)="onBack.emit()"></woa-button>
    </div>
}
